export const disablePointAfter = (amount) => {
  return amount.split(".")[1]?.length === 2;
};
